import React from 'react';

const CreditsYellow = ({ className, id, ...props }: SVGProps) => (
  <svg
    {...props}
    className={className}
    id={id}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1322_36951)">
      <rect
        width="40"
        height="40"
        rx="20"
        fill="white"
        style={{ mixBlendMode: 'luminosity' }}
      />
      <rect
        width="110"
        height="110"
        transform="translate(-35 -35)"
        fill="#FFE600"
      />
      <circle cx="19.9987" cy="20" r="11.6667" fill="white" />
      <path
        d="M7.58333 20V20.75H9.08333V20H7.58333ZM6.875 23.9166H6.125V25.4166H6.875V23.9166ZM10.375 27.4166H9.625V28.9166H10.375V27.4166ZM13.875 30.9166H13.125V32.4166H13.875V30.9166ZM19.7825 19.7548L19.976 19.0301L19.9708 19.0288L19.7825 19.7548ZM20.0718 19.8323L20.2701 19.109L20.2678 19.1084L20.0718 19.8323ZM20.2628 19.8847L20.4639 19.1621L20.4611 19.1613L20.2628 19.8847ZM19.9303 24.6666L19.9286 25.4166L19.9303 24.6666ZM30.9167 20C30.9167 26.0291 26.0291 30.9166 20 30.9166V32.4166C26.8575 32.4166 32.4167 26.8575 32.4167 20H30.9167ZM9.08333 20C9.08333 13.9709 13.9709 9.08331 20 9.08331V7.58331C13.1425 7.58331 7.58333 13.1424 7.58333 20H9.08333ZM20 9.08331C26.0291 9.08331 30.9167 13.9709 30.9167 20H32.4167C32.4167 13.1424 26.8575 7.58331 20 7.58331V9.08331ZM11.8333 23.9166H6.875V25.4166H11.8333V23.9166ZM15.3333 27.4166H10.375V28.9166H15.3333V27.4166ZM17.6667 30.9166H13.875V32.4166H17.6667V30.9166ZM23.9661 16.0088C23.4817 15.6244 22.9688 15.2574 22.3322 14.9941C21.6886 14.7279 20.9577 14.5833 20.0411 14.5833V16.0833C20.7912 16.0833 21.3231 16.2 21.759 16.3802C22.2018 16.5634 22.585 16.8278 23.0339 17.1839L23.9661 16.0088ZM20.0411 14.5833C19.1199 14.5833 18.2354 14.7704 17.5564 15.2177C16.8441 15.6871 16.3971 16.4231 16.3971 17.3634H17.8971C17.8971 16.9589 18.0637 16.6798 18.3816 16.4703C18.7329 16.2389 19.2954 16.0833 20.0411 16.0833V14.5833ZM16.3971 17.3634C16.3971 18.323 16.7781 19.0394 17.4271 19.5476C18.0248 20.0156 18.8151 20.2787 19.5943 20.4808L19.9708 19.0288C19.2158 18.833 18.6884 18.6301 18.3519 18.3666C18.0667 18.1433 17.8971 17.8629 17.8971 17.3634H16.3971ZM19.5891 20.4794C19.6863 20.5054 19.7815 20.5307 19.8759 20.5563L20.2678 19.1084C20.1703 19.082 20.0722 19.0559 19.976 19.0302L19.5891 20.4794ZM19.8736 20.5557L20.0646 20.608L20.4611 19.1613L20.2701 19.109L19.8736 20.5557ZM20.0618 20.6072C20.6941 20.7831 21.3105 20.9678 21.771 21.252C22.2024 21.5182 22.3908 21.8001 22.3908 22.1837H23.8908C23.8908 21.1026 23.2575 20.4067 22.5587 19.9755C21.8889 19.5621 21.0663 19.3297 20.4639 19.1621L20.0618 20.6072ZM22.3908 22.1837C22.3908 22.7329 22.2091 23.1273 21.8816 23.3994C21.5349 23.6874 20.9272 23.9189 19.932 23.9166L19.9286 25.4166C21.1341 25.4193 22.1317 25.1417 22.8401 24.5532C23.5676 23.9488 23.8908 23.0993 23.8908 22.1837H22.3908ZM19.932 23.9166C18.5453 23.9135 17.8615 23.3535 16.9499 22.6701L16.0501 23.8703C16.9497 24.5446 17.9941 25.4123 19.9286 25.4166L19.932 23.9166ZM19.25 12.9999V15.3333H20.75V12.9999H19.25ZM19.25 24.6666V27H20.75V24.6666H19.25Z"
        fill="black"
      />
    </g>
    <rect
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="black"
      stroke-opacity="0.07"
    />
    <defs>
      <clipPath id="clip0_1322_36951">
        <rect width="40" height="40" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(CreditsYellow);
